module.exports = __webpack_public_path__ + "assets/thumb-concierge@2x.cc3d7621.png";